import $ from "jquery";
import Bacon from "Bacon";
import "tooltip";
import "error";
import formHelpers from "form-helpers";
import c from "common";
import userdata from "user";
import ajax from "ajax";

var $body = $(document.body),
  userBus = new Bacon.Bus(),
  loginBus = new Bacon.Bus(),
  logoutBus = new Bacon.Bus(),
  emptyUser = {
    username: "",
    email: "",
    marketingConsent: "",
    emailIsForBilling: "",
    termsAccepted: false,
    services: [],
    originalUsername: "",
    elisaIdAuthenticated: false,
    elisaIdImpersonatorId: "",
    entertainmentCredentialsId: undefined
  };

var user = userBus.toProperty(getUserFromDOM());

function updateUser() {
  var promise = ajax.stream({
    url: "/api/user/",
    type: "GET",
    dataType: "json"
  });
  userBus.plug(promise);
  return promise.map(true);
}

function clearUserInfoInDom() {
  updateUserInfoToDom(emptyUser);
}

function updateUserInfoToDom(data) {
  var $loginHeader = $(".login-header");
  $loginHeader
    .attr('data-username', data.originalUsername)
    .attr('data-elisa-id-account-id', data.elisaIdAccountId)
    .attr('data-email', data.email)
    .attr('data-marketing-consent', data.marketingConsent)
    .attr('data-email-is-for-billing', data.emailIsForBilling)
    .attr('data-bearer', data.bearerToken)
    .attr('data-eclist', JSON.stringify(data.ecList || ''));
  $loginHeader.toggleClass("elisaid-authenticated", data.elisaIdAuthenticated);
  $loginHeader.toggleClass("elisaid-impersonated", !!data.elisaIdImpersonatorId);
  $loginHeader.find(".login-header-username").text(data.originalUsername);
  $body.toggleClass("stronglyIdentified", data.stronglyIdentified)
    .toggleClass("emailVerified", data.emailVerified)
    .toggleClass("termsAccepted", data.termsAccepted)
    .toggleClass("loggedin", !!data.username)
    .toggleClass("preview", !!data.preview)
    .attr('data-services', data.services.join(" "))
    .attr("data-credentialsId", parseInt(data.entertainmentCredentialsId, 10))
    .attr("data-cookiePermission", data.cookiePermission);
}

function ajaxForm($target) {
  return ajaxFormFromArray([$target, $target.serialize()]);
}

function ajaxFormFromArray(streamArray) {
  var $target = streamArray[0];
  var formData = streamArray[1];
  var formStream = ajax.stream({
    url: "/api" + $target.attr('action'),
    data: formData,
    type: "POST",
    dataType: $target.attr('data-type') ? $target.attr('data-type') : "json"
  });
  formHelpers.toggleError(false, $target);

  return formStream;
}

function isViihdeLoggedIn() {
  return $body.hasClass("loggedin");
}

function isOnlineOnlyLoggedIn() {
  var userData = getUserFromDOM();
  return isViihdeLoggedIn() && userData.hasNetpvr === false;
}

function isElisaIdOnlyLoggedIn() {
  return $body.hasClass("elisaidonly");
}

function setReferrer($target) {
  $target.find("input[name='referer']").val(window.location.pathname + window.location.search);
}

function partnerloginMissingPassword() {
  $('.partnerloginMissingPassword').addClass('partnerlogin-hide-link');
  $('.partnerlogin-password-missing-form').addClass('partnerlogin-show-form');
}

function partnerloginPasswordSent() {
  $('.partnerlogin-password-missing-form').removeClass('partnerlogin-show-form');
  $('.partnerlogin-password-done').addClass('partnerlogin-show-password-sent');
}

let loggedOut = false;
function unauthorized(stream) {
  stream.onError(function (event) {
    if (event.status === 403 && !loggedOut) {
      loggedOut = true;
      logoutBus.push(true);
    } else if (event.status === 401 && event.getResponseHeader('X-Elisa-ID-Session-Expired')) {
      loggedOut = false;
      window.location.href = window.location.href;
      return Bacon.never();
    } else {
      loggedOut = false;
    }
  });
  return stream;
}

function getUserFromDOM() {
  var userDataFromDom = userdata.fromDOM();
  var loginData = {
    isLoggedIn: isViihdeLoggedIn(),
    isElisaIdOnly: isElisaIdOnlyLoggedIn()
  };
  var localeData = {
    // locale: getCookie('locale') || 'fi'
    locale: 'fi'
  };

  return $.extend(userDataFromDom, loginData, localeData);
}

function getCookie(key) {
  if (!key) { return null; }
  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
}

function hasViihdeOnline(userData) {
  return userData.services.indexOf('viihdeonline') !== -1;
}

function doesNotHaveViihdeOnline(userData) {
  return !hasViihdeOnline(userData);
}

function handleGlobalLogoutForm() {
  $('.global-logout-button').on('click', function(e) {
    e.preventDefault(); // Stop the browser from doing anything else
    $('.global-logout-button').prop('disabled', true);
    $('.global-logout-button').text("Uloskirjatuminen käynnissä");
    $('#global-logout-response').html("<span style='color: green'>Pyyntö käynnissä</span>");
    $.ajax({
      type: "POST",
      url: "/api/user/global-logout",
      success: function() {
        location.reload();
      },
      error: function() {
        $('#global-logout-response').html("<span style='color: red'>Pyyntö epäonnistui</span>");
        $('.global-logout-button').prop('false', true);
        $('.global-logout-button').text("Kirjaudu ulos");
      }
    });
  });
}

userBus.plug(loginBus);
const loginWithUpdatedDom = loginBus.doAction(updateUserInfoToDom);
var logoutWithUpdatedDom = logoutBus.map(value => !value).doAction(clearUserInfoInDom);
var weakLoginState = loginWithUpdatedDom.filter(doesNotHaveViihdeOnline).map(true).merge(logoutWithUpdatedDom);
var credentialsLoginState = loginWithUpdatedDom.filter(hasViihdeOnline).map(true).merge(logoutWithUpdatedDom);

// Partner login page
$body.asEventStream("click", ".partnerloginMissingPassword").doAction(c.stopEvent).onValue(partnerloginMissingPassword);
$body.asEventStream("submit", ".partnerlogin-password-missing-form").doAction(c.stopEvent).map(c.$target).doAction(setReferrer).flatMap(ajaxForm).onValue(partnerloginPasswordSent);

// make property active
user.onValue(function () {
});

var userLogin = Bacon.combineWith(function (userData, viihdeLoggedIn, elisaIdUser) {
  userData.viihdeLoggedIn = viihdeLoggedIn;
  userData.elisaIdUser = elisaIdUser;
  return userData;
}, userBus, credentialsLoginState, weakLoginState.toProperty(isElisaIdOnlyLoggedIn()));

handleGlobalLogoutForm();

export default {
  unauthorized: unauthorized,
  reload: updateUser,
  state: credentialsLoginState,
  weakState: weakLoginState,
  onLogin: credentialsLoginState.filter(c.isTrue),
  onLogout: credentialsLoginState.filter(c.isFalse),
  stateProperty: credentialsLoginState.toProperty(isViihdeLoggedIn()),
  isLoggedIn: isViihdeLoggedIn,
  isOnlineOnlyLoggedIn: isOnlineOnlyLoggedIn,
  isElisaIdOnlyLoggedIn: isElisaIdOnlyLoggedIn,
  user: user,
  userLogin: userLogin,
  userStream: userBus,
  fromDOM: getUserFromDOM,
  login: function login(userData) {
    loginBus.push(userData);
  },
  logout: function logout() {
    logoutBus.push(true);
    userBus.push(emptyUser);
  }
};



// WEBPACK FOOTER //
// ./web/js/login.js